import LegalPage from '../components/LegalPage';
import termsBody from '../content/legal/terms.body.html?raw';

export default function TermsOfServicePage() {
  return <LegalPage title="Terms of Service" bodyHtml={termsBody} />;
}
